import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const TitleStyled = styled(Heading)(({ theme }) => ({
  lineHeight: '28px',
  margin: '10px 0px',
  [theme.breakpoints.up('sm')]: {
    marginTop: '40px',
    fontSize: '32px',
    marginBottom: '24px'
  }
}));

export const ImageWrapperStyled = styled(Stack)(({ theme }) => ({
  padding: '32px 38px',
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '16px'
}));

export const DescUploadImageStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'forMobileOnly'
})(({ theme, forMobileOnly }) => ({
  marginBottom: forMobileOnly ? '85px' : '48px',
  [theme.breakpoints.up('sm')]: {
    marginBottom: '40px'
  }
}));

export const CancelButtonStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.red.main
});

export const TextWrapStyled = styled(Box)(({ theme }) => ({
  marginBottom: '48px',
  [theme.breakpoints.up('sm')]: {
    marginBottom: '40px'
  }
}));

export const DialogActionsStyle = ({ theme }) => ({
  width: '100%',
  bottom: 0,
  right: 0,
  padding: '16px',
  position: 'fixed',
  [theme.breakpoints.up('sm')]: {
    display: 'box',
    padding: '16px 60px',
    maxWidth: '1450px',
    margin: 'auto'
  }
});

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: '0',
  '::-webkit-scrollbar': {
    display: 'none'
  }
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));
